/**
 * @generated SignedSource<<ceb39a636684f2f84408947def4a7e75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfirmDraftPackageInput = {
  memberPackageId: string;
  paymentMethodId: string;
};
export type useConfirmDraftMemberPackageMutation$variables = {
  input: ConfirmDraftPackageInput;
};
export type useConfirmDraftMemberPackageMutation$data = {
  readonly confirmDraftPackage: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly memberPackage: {
      readonly id: string;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useConfirmDraftMemberPackageMutation = {
  response: useConfirmDraftMemberPackageMutation$data;
  variables: useConfirmDraftMemberPackageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberPackage",
  "kind": "LinkedField",
  "name": "memberPackage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConfirmDraftMemberPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmDraftPackagePayload",
        "kind": "LinkedField",
        "name": "confirmDraftPackage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfirmDraftMemberPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmDraftPackagePayload",
        "kind": "LinkedField",
        "name": "confirmDraftPackage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac23ee1fbe1cc00d526674c3d2ebffa8",
    "id": null,
    "metadata": {},
    "name": "useConfirmDraftMemberPackageMutation",
    "operationKind": "mutation",
    "text": "mutation useConfirmDraftMemberPackageMutation(\n  $input: ConfirmDraftPackageInput!\n) {\n  confirmDraftPackage(input: $input) {\n    success\n    errors {\n      __typename\n      code\n      field\n      message: code\n    }\n    memberPackage {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab7bb256ea853f7b4eb22d5e7a148ee3";

export default node;
